export const EntitlementBlackList = ['atlassian.organisation', 'atlassian.cloud'];
